module.exports = __webpack_public_path__ + "static/media/outdoors.98c639d1.jpg";